import ContentPlayer from "./content/ContentPlayer";
export default ContentPlayer;
